<ng-content></ng-content>
<span *ngIf="loading" class="is-sr-only">is loading</span>
